import { createActions, createReducer } from "reduxsauce"
import { Types as LoaderTypes } from "model/data"

export const { Types, Creators } = createActions({
  factorsSearch: ["search"],
  resetFactorSearch: [],
  toggleFactorsSearch: [],
}, {
  prefix: "ompnt/modules/optimizationSettings",
})

const DEFAULT_STATE = {
  factorsSearchVisible: false,
  factorsSearchValue: null,
}

function handleLoadSuccess(state, action) {
  if (action.resource === "portfolio") {
    return { ...state, ...DEFAULT_STATE }
  } else {
    return state
  }
}

function handleFactorsSearch(state, { search }) {
  return { ...state, factorsSearchValue: search }
}

function handleResetFactorSearch(state) {
  return {
    ...state,
    factorsSearchValue: null,
    factorsSearchVisible: false,
  }
}

function handleToggleFactorsSearch(state) {
  return { ...state, factorsSearchVisible: !state.factorsSearchVisible }
}

export default createReducer(DEFAULT_STATE, {
  [Types.FACTORS_SEARCH]: handleFactorsSearch,
  [Types.RESET_FACTOR_SEARCH]: handleResetFactorSearch,
  [Types.TOGGLE_FACTORS_SEARCH]: handleToggleFactorsSearch,
  [LoaderTypes.LOAD_SUCCESS]: handleLoadSuccess,
})
